module.exports = __webpack_public_path__ + "img/upload_photo.5b8199e5.svg";